<template>
  <b-table hover :items="typeInfo.items" :fields="typeInfo.fields" head-variant="light" bordered>
    <template #cell(chrom)="typeInfo">
        {{typeInfo.index+1}}
    </template>
    <template #cell(S+L)="typeInfo">
        {{Math.round((typeInfo.item.S + typeInfo.item.L)*100)/100}}
    </template>
    <template #cell(AR)="typeInfo">
        {{Math.round(typeInfo.item.L/typeInfo.item.S*100)/100}}
    </template>
  </b-table>
</template>

<script>
import typeInfo from "./chromTypeInfo.json"

export default {
  data() {
    return {
      typeInfo
    }
  }
}
</script>

<style>

</style>